import { render, staticRenderFns } from "./FilmPosterForm.vue?vue&type=template&id=8bc05bc8&"
import script from "./FilmPosterForm.vue?vue&type=script&lang=js&"
export * from "./FilmPosterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports